export default __webpack_public_path__ + "static/pl-a33451c4974c748a833b2c4b110c51f4.svg";